import { Row, Col, Image } from "antd";

export const KollupitiyaMarket = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="kollupitiya-market">Kollupitiya Market</h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            In 2024, Eng. Nahil Wijesuriya, Chairman of East West Properties
            PLC, led a landmark Corporate Social Responsibility (CSR) initiative
            to restore and modernize the Kollupitiya Supermarket, a Colombo
            landmark long in need of renewal. The project, completed at a cost
            of Rs. 29 million, exemplified Nahil’s lifelong commitment to
            community upliftment and sustainable urban development.
          </p>
          <p>
            The beautification and modernization project, launched in March 2024
            and completed within a few months, transformed the aging public
            space into a clean, safe, and vibrant environment for both vendors
            and shoppers. The work included modern cladding for the building’s
            façade, deep cleaning and restoration of interiors, rubble wall
            washing, and gate restoration, all executed to the highest aesthetic
            and hygiene standards.
          </p>
          <p>
            Speaking on the project, Nahil emphasized that it reflected his
            belief that business success and social responsibility must go hand
            in hand. The supermarket’s transformation not only enhanced
            Colombo’s urban landscape but also supported the livelihoods of
            local vendors and improved the shopping experience for the
            community.
          </p>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/71-Kollupitiya-Market/ceylon-today-front-page.png"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Ceylon Today</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/71-Kollupitiya-Market/ceylon-today-full-article.png"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Ceylon Today</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "50%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/71-Kollupitiya-Market/principle-commissioner.png"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "50%" }}>
              <p>
                <small>Municipal Commissioner</small>
              </p>
            </div>
          </div>
        </Col>
        <p>ADD CMC ALBUM</p>
      </Row>
    </div>
  );
};
